import { TimestampDate } from '~/common/entities/Employees/EmployeeTypes';
import React, { PropsWithChildren } from 'react';

type EmployeeId = number;

interface IWarningContext {
  openEmployee?: EmployeeId | null | undefined;
  date?: TimestampDate | null | undefined;
  open(employeeId: EmployeeId, date?: TimestampDate): void;
  close(): void;
}

export const WarningContext = React.createContext<IWarningContext>(
  // Dirty Type hack, but necessary because there is no  default context
  null as unknown as IWarningContext,
);
export const WarningContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [openEmployee, setOpenEmployee] = React.useState<EmployeeId | null>();
  const [date, setDate] = React.useState<TimestampDate | null>();
  const open = (employee: EmployeeId, date?: TimestampDate) => {
    setOpenEmployee(employee);
    setDate(date);
  };
  const close = () => {
    setOpenEmployee(null);
    setDate(null);
  };
  return (
    <WarningContext.Provider value={{ openEmployee, open, close, date }}>
      {children}
    </WarningContext.Provider>
  );
};

export const useWarningContext = () => {
  const context = React.useContext(WarningContext);
  if (!context) {
    throw new Error('Must be wrapped in Provider.');
  }
  return context;
};
